import { Status } from '@/components/ui/Status'
import { JOB_STATUS_META } from '@/lib/status'
import type { JobStatus } from '@/types/api'

export function JobStatusBadge({ status }: { status: JobStatus }) {
  return <Status meta={JOB_STATUS_META[status]} variant="badge" />
}
